// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IBlockTypePropertyValueData {
  id: string | number | boolean | null;
  title: string;
  data?: number;
}
